import { render, staticRenderFns } from "./OrgCollapses.vue?vue&type=template&id=27fa2c3c&scoped=true&"
import script from "./OrgCollapses.vue?vue&type=script&lang=js&"
export * from "./OrgCollapses.vue?vue&type=script&lang=js&"
import style0 from "./OrgCollapses.vue?vue&type=style&index=0&id=27fa2c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa2c3c",
  null
  
)

export default component.exports